// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"MediaCarousel_carouselContainer__I4eKt","carousel":"MediaCarousel_carousel__32wbX"};